/* Amy Lucy footer newsletter: native Shopify submission in a same-origin frame.
   Let Shopify handle CAPTCHA; never submit the same address a second time
   automatically or label a submission successful without server confirmation. */
(function () {
  'use strict';

  var SUCCESS = "You're on the list! Thanks for joining the Amy Lucy Letter.";
  var CONFIRMATION_MS = 8000;
  var MAX_WAIT_MS = 25000;

  function initialise(root) {
    var form = root.querySelector('form.hdt-newsletter__form');
    var email = form && form.querySelector('input[name="contact[email]"]');
    var button = form && form.querySelector('button[type="submit"]');
    var message = root.querySelector('[data-al-newsletter-feedback]');
    if (!form || !email || !button || !message || form.dataset.alNewsletterReady === 'true') return;
    form.dataset.alNewsletterReady = 'true';

    var pending = false;
    var closingTimer = 0;
    var waitTimer = 0;
    var frame = null;
    var frameName = 'al-newsletter-frame-' + form.id.replace(/[^A-Za-z0-9_-]/g, '');
    var buttonLabel = button.querySelector('.hdt-newsletter__text');
    var originalLabel = buttonLabel ? buttonLabel.textContent : '';
    var nativeSuccess = form.querySelector('.hdt-newsletter__success');
    if (nativeSuccess) {
      // Shopify rendered a confirmed native success after a previous navigation.
      // Hide the permanent theme notice and show only the timed confirmation.
      nativeSuccess.hidden = true;
      show(SUCCESS, 'success');
    }

    function resetFeedback() {
      clearTimeout(closingTimer);
      message.textContent = '';
      message.removeAttribute('data-state');
      message.setAttribute('role', 'status');
    }

    function show(value, type) {
      resetFeedback();
      message.dataset.state = type;
      message.setAttribute('role', type === 'error' ? 'alert' : 'status');
      message.textContent = value;
      if (type === 'success') closingTimer = setTimeout(resetFeedback, CONFIRMATION_MS);
    }

    function resetButton() {
      pending = false;
      button.removeAttribute('aria-busy');
      // Do not disable the button: disabled styling changes the original colour.
      if (buttonLabel) buttonLabel.textContent = originalLabel;
    }

    function finishSuccessful() {
      clearTimeout(waitTimer);
      resetButton();
      email.value = '';
      if (nativeSuccess) nativeSuccess.hidden = true;
      if (frame) frame.remove();
      frame = null;
      form.removeAttribute('target');
      show(SUCCESS, 'success');
      try { sessionStorage.removeItem('the4:recentform'); } catch (ignore) {}
    }

    function finishFailed(errorText) {
      clearTimeout(waitTimer);
      resetButton();
      if (frame) frame.remove();
      frame = null;
      form.removeAttribute('target');
      show(errorText || "We couldn't confirm your sign-up. Please try again.", 'error');
      try { sessionStorage.removeItem('the4:recentform'); } catch (ignore) {}
    }

    function showSecurityChallenge(doc) {
      clearTimeout(waitTimer);
      var prompt = root.querySelector('[data-al-newsletter-challenge]');
      if (!prompt) {
        prompt = document.createElement('div');
        prompt.setAttribute('data-al-newsletter-challenge', '');
        prompt.style.cssText = 'margin-top:12px;font:400 14px/1.5 Lato,Arial,sans-serif;color:#4A0828;';
        root.appendChild(prompt);
      }
      prompt.textContent = 'Please complete the Shopify security check below to finish joining.';
      if (frame) {
        frame.style.cssText = 'display:block;width:100%;height:440px;margin-top:12px;border:1px solid #F0DCE4;border-radius:5px;background:#fff;';
        frame.removeAttribute('aria-hidden');
        frame.tabIndex = 0;
      }
      resetFeedback();
    }

    email.addEventListener('input', function () {
      if (!pending) resetFeedback();
    });

    form.addEventListener('submit', function (event) {
      if (pending) {
        // Shopify may re-submit after CAPTCHA has prepared the token.
        // Leave that native submission alone so the challenge can complete.
        return;
      }
      if (event.defaultPrevented || !form.checkValidity()) return;

      resetFeedback();
      pending = true;
      button.setAttribute('aria-busy', 'true');
      if (buttonLabel) buttonLabel.textContent = 'Joining…';

      // Set form.target BEFORE the browser's native submission. This keeps the
      // surrounding document and scroll position untouched.
      frame = document.createElement('iframe');
      frame.name = frameName;
      frame.title = 'Newsletter submission';
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      frame.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0;';
      root.appendChild(frame);
      form.setAttribute('target', frameName);

      frame.addEventListener('load', function () {
        if (!pending || !frame) return;
        var href = '';
        var doc = null;
        try {
          href = frame.contentWindow.location.href;
          doc = frame.contentDocument;
        } catch (ignore) {
          // A cross-origin security challenge cannot be treated as success.
          return;
        }
        if (!href || href === 'about:blank' || !doc) return;

        var url;
        try { url = new URL(href); } catch (ignore) { return; }
        if (url.pathname.indexOf('/challenge') === 0 ||
            doc.querySelector('#shopify-challenge')) {
          showSecurityChallenge(doc);
          return;
        }

        var returned = doc.getElementById(form.id);
        var serverSuccess = url.searchParams.get('customer_posted') === 'true' ||
          !!(returned && returned.querySelector('.hdt-newsletter__success'));
        var returnedError = returned && returned.querySelector('.hdt-newsletter__error');
        if (serverSuccess) {
          finishSuccessful();
        } else if (returnedError) {
          finishFailed(returnedError.textContent.trim());
        } else {
          finishFailed("We couldn't confirm your sign-up. Please try again.");
        }
      });

      waitTimer = setTimeout(function () {
        if (pending) finishFailed('The sign-up has not been confirmed. Please try again.');
      }, MAX_WAIT_MS);

      // Intentionally leave the browser's native Shopify submit in place.
      // Shopify hCaptcha retains control; no AJAX retry or top-page redirect.
    }, true);
  }

  function initialiseAll() {
    document.querySelectorAll('.al-footer-newsletter-form').forEach(initialise);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', initialiseAll);
})();